export { default } from './UserMenu';



// WEBPACK FOOTER //
// ./src/components/base/UserMenu/index.js